export default {
    meta: {
        title: '合同管理',
        isShowNav: true,
    },
};
